import React from "react";

export default function BillsSearchSkeleton() {
  return (
    <div
      className="bills-page__search-skeleton form-control"
      aria-hidden="true"
    >
      <div className="skeleton-icon" />
      <div className="skeleton-line skeleton-line--input" />
    </div>
  );
}
